export const windowEnvVar = (varName: string) => {
  const value = (window as any).env && (window as any).env[varName];
  return value && value !== `%${varName}%` ? value : null;
};

export const requiredEnvVar = (varName: string) => {
  const result = windowEnvVar(varName) ?? process.env[varName] ?? process.env[`REACT_APP_${varName}`] ?? "";
  if (!result) {
    throw new Error(`Missing env var ${varName}`);
  }
  return result;
};
